export default __webpack_public_path__ + "static/media/svg-cook.157278cb.svg";